import axios from 'axios';

export default {
  getAppInfo({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/appinfo/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertAppInfo', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeAppInfo({ commit, state }, platformId) {
    return new Promise((resolve, reject) => {
      commit('removeAppInfoRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/appinfo/remove`,
        params: { id: platformId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeAppInfoRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeAppInfoRequestError', err);
          reject(err);
        });
    });
  },
  removeAllAppInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('removeAllAppInfoRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/appinfo/removeAll`,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeAllAppInfoRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeAllAppInfoRequestError', err);
          reject(err);
        });
    });
  }
};
